<template lang="pug">
    Modal
        .form
            h2 Create a New Product Group
            .form__control-group
                label Name
                input(
                    v-model="name"
                    type="text"
                    placeholder="Name"
                )
            .form__control-group.rule__control-group--select(
                v-if="getMarkets.length > 1"
            )
                label Default Market
                select.form__select(
                    v-model="market"
                )
                    option(
                        value=""
                        disabled
                        selected
                    ) Select Market
                    option(
                        :key="market.name"
                        v-for="(market, index) in getMarkets"
                        :value="market"
                    ) {{market.title}} - {{market.primaryLanguage}}
            button.button__submit(
                @click="submit"
            ) Create
            p.validation__error(
                v-if="showError"
            ) Please enter a Name and Default Market.
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import { postResource } from '../../services/Utils';
import Services from '../../services/Services';
import VueNotifications from 'vue-notifications';
export default {
  name: 'CreateProductGroup',
  components: {
    Modal
  },
  computed: {
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  data() {
    return {
      name: '',
      market: '',
      showError: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit() {
      if (!this.name || !this.market) {
        this.showError = true;
        return false;
      }
      let newProductGroup = {};

      newProductGroup.title = this.name;
      newProductGroup.markets = this.market._id;

      newProductGroup.fallbackLocale = this.market.locale;

      postResource('/v1/productgroups/create', false, newProductGroup)
        .then(res => {
          console.log('success!', res);
          this.showSuccessMsg({ message: `${this.name} product group created!` });
          store.commit('hideModals', true);
          this.$router.push(`/product-groups/${res.productGroup._id}`);
          return res;
        })
        .catch(error => {
          let message = 'An error occurred. Please try again.';
          if (error.message) {
            message = error.message;
          }
          this.showErrorMsg({
            message
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.form {
  padding: 2rem;
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;

  h2 {
    text-align: center;
    width: 100%;
  }

  .form__control-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    width: 100%;

    label {
      margin-bottom: 5px;
    }

    &:after {
      top: 20px !important;
    }

    input {
      padding-left: 0.5rem;
      height: 40px;
    }

    select,
    option {
      text-transform: capitalize;
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/components/modals/CreateProductGroup.vue